/** Interfaccia per generare un breve messaggio da passare alla modale */
export interface EBWModalShortMessage {

  /** Contenuto della modale */
  content: string;

}

/** Interfaccia per generare un messaggio completo da passare alla modale */
export interface EBWModalMessage extends EBWModalShortMessage {

  /** title dela modale */
  title: string;

}

/** Interfaccia per genearare una modale custom */
export interface EBWModalMessageCustom extends EBWModalMessage {

  /** Tipologia di modale */
  type: EBWModalType;

}

export enum EBWModalType {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Confirm = 'confirm',
  Success = 'success',
  Loading = 'loading',
  Custom = 'custom'
}

export enum EBWModalResult {
  Cross = 'cross',
  Close = 'close',
  Cancel = 'cancel',
  Confirm = 'confirm',
}

// In caso di select, il campo value è cosi composto
// value = [{name: field.name, property: field.property}]
export interface EBWDynamicModel {
  title: string;
  fieldsToDisplay: { field: string, value: any, edit: boolean, type?: 'input' | 'select', last_field?: string, last_value?: any, modelSelect?: any }[];
  translate_path?: string;
  typeInput?: '' | 'text' | 'number';
  isLastAndNew?: boolean;
}
